import type {SavedLocation} from 'src/customers/saved-locations/schemas'
import type {JobLocation} from 'src/jobs/types'

/** About 100 m. */
const SAME_PLACE_DEGREES = 0.001

export function locationFromSavedSite(site: SavedLocation): JobLocation {
    return {
        name: site.name,
        notes: site.notes ?? '',
        positionMode: 'latlng',
        latitude: site.latitude,
        longitude: site.longitude,
        addressText: site.fullAddress,
        fromSavedLocationId: site.id,
        rememberAsSavedLocation: false,
        savedLocationMode: 'select-saved',
    }
}

/** Match a location to a saved site by source id, or by name and coordinates when no id is set. */
export function savedSiteOf(location: JobLocation, savedSites: SavedLocation[]) {
    if (location.fromSavedLocationId) {
        return savedSites.find((site) => site.id === location.fromSavedLocationId) ?? null
    }

    const name = location.name.trim().toLowerCase()
    return (
        savedSites.find(
            (site) =>
                site.name.trim().toLowerCase() === name &&
                location.latitude != null &&
                location.longitude != null &&
                Math.abs(site.latitude - location.latitude) < SAME_PLACE_DEGREES &&
                Math.abs(site.longitude - location.longitude) < SAME_PLACE_DEGREES,
        ) ?? null
    )
}
